import Tooltip from '@material-ui/core/Tooltip';
import { getPaymentBrand } from 'helpers/constants';
import React from 'react';

import type { ISubscriptionInvoice } from 'v2/interfaces/subscriptions';

import { useStyles } from './styles';

interface IProps {
  invoice: ISubscriptionInvoice;
}

export const PaymentImg = ({ invoice }: IProps) => {
  const classes = useStyles();

  const getPaymentImgTitle = (invoice: ISubscriptionInvoice): string => {
    if (!invoice) {
      return '';
    }
    if (invoice?.card_brand) {
      return invoice.card_brand;
    }
    return getPaymentBrand(invoice?.payment_method?.name || 'desconhecido').alias;
  };

  const getPaymentImgUrl = (invoice: ISubscriptionInvoice): string => {
    if (!invoice) {
      return '';
    }
    if (invoice?.payment_method?.name === 'Credito') {
      return getPaymentBrand(invoice?.card_brand || 'desconhecido').url;
    }
    return getPaymentBrand(invoice?.payment_method?.name || 'desconhecido').url;
  };

  const title = getPaymentImgTitle(invoice);
  const url = getPaymentImgUrl(invoice);

  return (
    <Tooltip placement='top' title={title}>
      <img className={classes.img} title={title} alt={title} src={url} />
    </Tooltip>
  );
};
